import authSagas from './auth/sagas';
import apiSagas from './api/sagas';
import { fork } from 'redux-saga/effects';

export default function* rootSaga() {
	yield fork(authSagas);
	yield fork(apiSagas);
}
